import { useCallback, useState } from 'react';

import { sowStateOnExit } from '@comeon/analytics';

import FlowBlocker from '~/components/authentication/flow-blocker';
import { useCloseCurrentContext } from '~/hooks/use-close-context';

import SourceOfWealth from './sow';

const SOWWrapper = () => {
	/**
	 * to store the current state of the form, i.e. which step is the user in
	 */
	const [currentSOWFormState, setCurrentSOWFormState] = useState('pageload');

	const closeSidebar = useCloseCurrentContext();

	const onClose = useCallback(() => {
		sowStateOnExit(currentSOWFormState);
		closeSidebar();
	}, [closeSidebar, currentSOWFormState]);

	return (
		<FlowBlocker onCancel={onClose}>
			<SourceOfWealth
				currentSOWFormState={currentSOWFormState}
				setCurrentSOWFormState={setCurrentSOWFormState}
				onClose={onClose}
			/>
		</FlowBlocker>
	);
};

export default SOWWrapper;
